import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Tabs, Tab, Alert } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { disconnectWebsocket } from "../../../store/actions/websocketActions";
import ActiveForms from "./forms/ActiveForms";
import AddForms from "./forms/AddForms";

const FormsManagement = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State management
  const [activeTab, setActiveTab] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const dispatchCount = useRef(0);

  // Check admin access
  useEffect(() => {
    if (currentUser?.user) {
      if (currentUser?.user?.role !== "admin" || !currentUser?.user?.admin) {
        if (dispatchCount.current < 1) {
          dispatch(disconnectWebsocket(currentSession));
          navigate("/login");
          dispatchCount.current += 1;
        }
      }
    }
  }, [currentUser?.user, dispatch, currentSession, navigate]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Handle messages from child components
  const handleError = (errorMessage) => {
    setError(errorMessage);
  };

  const handleSuccess = (successMessage) => {
    setSuccess(successMessage);
  };

  if (
    !currentUser ||
    currentUser?.user?.role !== "admin" ||
    !currentUser?.user?.admin
  ) {
    return null;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" color="primary" component="h1" sx={{ mb: 3 }}>
        Forms Management
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert
          severity="success"
          sx={{ mb: 2 }}
          onClose={() => setSuccess(null)}
        >
          {success}
        </Alert>
      )}

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Active Forms" />
          <Tab label="Add Forms" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <ActiveForms
          onError={handleError}
          onSuccess={handleSuccess}
          currentSession={currentSession}
        />
      )}

      {activeTab === 1 && (
        <AddForms
          onError={handleError}
          onSuccess={handleSuccess}
          currentSession={currentSession}
        />
      )}
    </Box>
  );
};

export default FormsManagement;
